(function () {
  const PREFIX = 'tylae_wishlist_v3_';

  let observer = null;
  let updateScheduled = false;
  let cartActionRunning = false;


  /* =========================================================
     OUTILS
  ========================================================= */

  function getCountry() {
    if (
      window.Shopify &&
      window.Shopify.country
    ) {
      return String(
        window.Shopify.country
      ).toUpperCase();
    }

    const select = document.querySelector(
      'form[action*="/localization"] select[name="country_code"]'
    );

    if (
      select &&
      select.value
    ) {
      return select.value.toUpperCase();
    }

    return '';
  }


  function getSavedData(variantId) {
    const country = getCountry();

    if (
      !country ||
      !variantId
    ) {
      return null;
    }

    try {
      const raw =
        localStorage.getItem(
          PREFIX +
          country +
          '_' +
          variantId
        );

      return raw
        ? JSON.parse(raw)
        : null;

    } catch (e) {
      return null;
    }
  }


  function getVariantId(link) {
  if (!link) return '';

  try {
    const url = new URL(
      link.href,
      window.location.origin
    );

    /* 1. Si Wishlist Hero fournit encore ?variant= */
    const variantFromUrl =
      url.searchParams.get('variant');

    if (variantFromUrl) {
      return variantFromUrl;
    }

    /* 2. Sinon on retrouve la variante mémorisée
       pour ce produit et ce marché */
    const match =
      url.pathname.match(
        /\/products\/([^\/]+)/
      );

    if (!match) {
      return '';
    }

    const handle = match[1];
    const country = getCountry();

    if (!handle || !country) {
      return '';
    }

    return (
      localStorage.getItem(
        PREFIX +
        'handle_' +
        country +
        '_' +
        handle
      ) || ''
    );

  } catch (e) {
    return '';
  }
}


  /* =========================================================
     SAUVEGARDE DE LA TAILLE ACTUELLE
     SUR LA FICHE PRODUIT
  ========================================================= */

  function getProductForm() {
    const root =
      document.querySelector('.product') ||
      document.querySelector(
        '[data-section-type="product"]'
      );

    if (!root) return null;

    return root.querySelector(
      'form[data-product-form]'
    );
  }


  function saveCurrentProductSize() {
    const form =
      getProductForm();

    if (!form) return;

    const variantInput =
      form.querySelector(
        '[name="id"]'
      );

    if (
      !variantInput ||
      !variantInput.value
    ) {
      return;
    }

    const variantId =
      String(
        variantInput.value
      );


    /*
     * ON LIT UNIQUEMENT les valeurs déjà
     * correctement calculées par product-form.liquid.
     *
     * On ne les modifie jamais ici.
     */

    const bandInput =
      form.querySelector(
        '[name="properties[_displayed_band_size]"]'
      );

    const cupInput =
      form.querySelector(
        '[name="properties[_displayed_cup_size]"]'
      );

    const systemInput =
      form.querySelector(
        '[name="properties[_displayed_size_system]"]'
      );

    const countryInput =
      form.querySelector(
        '[name="properties[_displayed_country_code]"]'
      );


    const band =
      bandInput
        ? bandInput.value.trim()
        : '';

    const cup =
      cupInput
        ? cupInput.value.trim()
        : '';

    const system =
      systemInput
        ? systemInput.value.trim()
        : '';

    const country =
      countryInput &&
      countryInput.value
        ? countryInput.value
            .trim()
            .toUpperCase()
        : getCountry();


    /*
     * Produit XS/S/M/L etc. :
     * pas besoin de notre système
     * soutien-gorge.
     */
    if (
      !band ||
      !cup ||
      !system ||
      !country
    ) {
      return;
    }


    /*
     * On essaie également de mémoriser
     * le titre Shopify natif.
     *
     * Exemple :
     * Mahogany / 28 / D
     */
    let nativeTitle = '';

    if (
      variantInput.tagName ===
      'SELECT'
    ) {
      const option =
        variantInput.options[
          variantInput.selectedIndex
        ];

      if (option) {
        nativeTitle =
          option.textContent
            .replace(/\s+/g, ' ')
            .trim();
      }
    }


    const data = {
      variantId: variantId,

      band: band,
      cup: cup,

      system: system,
      country: country,

      nativeTitle: nativeTitle
    };


    try {
  /* Données de taille marché */
  localStorage.setItem(
    PREFIX +
      country +
      '_' +
      variantId,

    JSON.stringify(data)
  );


  /* Association produit → variante sélectionnée */
  const match =
    window.location.pathname.match(
      /\/products\/([^\/]+)/
    );

  if (match && match[1]) {
    const handle = match[1];

    localStorage.setItem(
      PREFIX +
      'handle_' +
      country +
      '_' +
      handle,

      variantId
    );
  }

} catch (e) {}

}

  /* =========================================================
     AFFICHAGE WISHLIST
  ========================================================= */

  function getProductName(
    link,
    data
  ) {
    const current =
      (
        link.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim();

    if (!current) return '';


    /*
     * Déjà traité :
     * on conserve le nom.
     */
    if (
      link.dataset.tgProductName
    ) {
      return (
        link.dataset
          .tgProductName
      );
    }


    let name = current;


    /*
     * Cas idéal :
     * nativeTitle est connu.
     */
    if (
      data.nativeTitle &&
      current.includes(
        data.nativeTitle
      )
    ) {
      name =
        current
          .replace(
            data.nativeTitle,
            ''
          )
          .replace(
            /\s*-\s*$/,
            ''
          )
          .trim();

    } else {

      /*
       * Sécurité :
       *
       * MAHOGANY BASQUE -
       * Mahogany / 28 / D
       *
       * devient simplement :
       *
       * MAHOGANY BASQUE
       */
      const separator =
        current.indexOf(
          ' - '
        );

      if (
        separator !== -1
      ) {
        name =
          current
            .slice(
              0,
              separator
            )
            .trim();
      }
    }

    return name;
  }


  function updateCard(card) {
    const productLink =
      card.querySelector(
        '.wishlist-hero-list-card-header-product-name'
      );

    if (!productLink) return;


    const variantId =
      getVariantId(
        productLink
      );

    if (!variantId) return;


    const data =
      getSavedData(
        variantId
      );


    /*
     * Aucune donnée marché :
     * Wishlist Hero reste intact.
     */
    if (
      !data ||
      !data.band ||
      !data.cup ||
      !data.system
    ) {
      return;
    }


    /* -------------------------
       NOM DU PRODUIT
    ------------------------- */

    const productName =
      getProductName(
        productLink,
        data
      );


    if (
      productName &&
      productLink.dataset
        .tgTitleDone !== 'true'
    ) {
      productLink.textContent =
        productName;

      productLink.dataset
        .tgProductName =
        productName;

      productLink.dataset
        .tgTitleDone =
        'true';
    }


    /* -------------------------
       TAILLE MARCHÉ
    ------------------------- */

    const header =
      card.querySelector(
        '.MuiCardHeader-content'
      );

    if (!header) return;


    let sizeElement =
      header.querySelector(
        '.tg-wishlist-market-size'
      );


    if (!sizeElement) {
      sizeElement =
        document.createElement(
          'span'
        );

      sizeElement.className =
        'tg-wishlist-market-size';


      const title =
        header.querySelector(
          '.MuiCardHeader-title'
        );


      if (title) {
        title.insertAdjacentElement(
          'afterend',
          sizeElement
        );
      } else {
        header.appendChild(
          sizeElement
        );
      }
    }


    const lang =
      (
        document.documentElement
          .getAttribute('lang') ||
        ''
      ).toLowerCase();


    const label =
      lang.includes('fr')
        ? 'Taille'
        : 'Size';


    const wantedText =
  `${data.cup}${data.band}`;


    if (
      sizeElement.textContent !==
      wantedText
    ) {
      sizeElement.textContent =
        wantedText;
    }
  }


  function updateWishlist() {
    document
      .querySelectorAll(
        '.wishlist-hero-list-card'
      )
      .forEach(
        updateCard
      );
  }



  /* =========================================================
     WISHLIST → PANIER
     AJOUT DIRECT À SHOPIFY
  ========================================================= */

  function buildCartItem(card) {
    const productLink =
      card.querySelector(
        '.wishlist-hero-list-card-header-product-name'
      );

    if (!productLink) {
      return null;
    }


    const variantId =
      getVariantId(
        productLink
      );

    if (!variantId) {
      return null;
    }


    const data =
      getSavedData(
        variantId
      );


    /*
     * Produit classique sans taille
     * bonnet/tour :
     *
     * on peut quand même l'ajouter.
     */
    if (!data) {
      return {
        id: Number(
          variantId
        ),
        quantity: 1
      };
    }


    return {
      id: Number(
        variantId
      ),

      quantity: 1,

      properties: {
        _displayed_band_size:
          data.band || '',

        _displayed_cup_size:
          data.cup || '',

        _displayed_size_system:
          data.system || '',

        _displayed_country_code:
          data.country ||
          getCountry()
      }
    };
  }


  async function addItemsToShopify(
    items
  ) {
    const response =
      await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              items: items
            })
        }
      );


    if (!response.ok) {
      throw new Error(
        'Shopify cart add failed'
      );
    }


    return response.json();
  }


  async function addWishlistCardToCart(
    button
  ) {
    if (cartActionRunning) {
      return;
    }


    const card =
      button.closest(
        '.wishlist-hero-list-card'
      );

    if (!card) return;


    const item =
      buildCartItem(
        card
      );

    if (!item) return;


    cartActionRunning =
      true;


    try {
      button.disabled =
        true;

      button.style.opacity =
        '0.6';

      button.style
        .pointerEvents =
        'none';


      await addItemsToShopify([
        item
      ]);


      /*
       * IMPORTANT :
       *
       * L'article est déjà créé
       * avec 75 / D / FR AVANT
       * l'ouverture du panier.
       *
       * Aucun correctif / reload
       * nécessaire sur /cart.
       */
      window.location.href =
        '/cart';


    } catch (error) {
      console.error(
        'TYLAË Wishlist cart error:',
        error
      );


      button.disabled =
        false;

      button.style.opacity =
        '';

      button.style
        .pointerEvents =
        '';


      cartActionRunning =
        false;
    }
  }


  async function addAllWishlistToCart(
    button
  ) {
    if (cartActionRunning) {
      return;
    }


    const cards =
      Array.from(
        document.querySelectorAll(
          '.wishlist-hero-list-card'
        )
      );


    const items =
      cards
        .map(
          buildCartItem
        )
        .filter(Boolean);


    if (!items.length) {
      return;
    }


    cartActionRunning =
      true;


    try {
      button.disabled =
        true;

      button.style.opacity =
        '0.6';

      button.style
        .pointerEvents =
        'none';


      await addItemsToShopify(
        items
      );


      window.location.href =
        '/cart';


    } catch (error) {
      console.error(
        'TYLAË Wishlist Add All error:',
        error
      );


      button.disabled =
        false;

      button.style.opacity =
        '';

      button.style
        .pointerEvents =
        '';


      cartActionRunning =
        false;
    }
  }



  /* =========================================================
     OBSERVER WISHLIST HERO
  ========================================================= */

  function scheduleUpdate() {
    if (
      updateScheduled
    ) {
      return;
    }


    updateScheduled =
      true;


    requestAnimationFrame(
      function () {
        updateScheduled =
          false;


        /*
         * On coupe l'observer pendant
         * nos propres modifications.
         */
        if (observer) {
          observer.disconnect();
        }


        updateWishlist();


        if (observer) {
          observer.observe(
            document.body,
            {
              childList: true,
              subtree: true
            }
          );
        }
      }
    );
  }



  /* =========================================================
     ÉVÉNEMENTS
  ========================================================= */


  /*
   * Quand la cliente change une taille,
   * product-form.liquid remplit d'abord
   * les propriétés.
   *
   * Nous les lisons juste après.
   */
  document.addEventListener(
    'click',
    function (event) {

      if (
        event.target.closest(
          '.product__option[data-product-option]'
        )
      ) {
        setTimeout(
          saveCurrentProductSize,
          100
        );

        setTimeout(
          saveCurrentProductSize,
          250
        );
      }


      /*
       * ADD TO WISHLIST :
       *
       * dernière sauvegarde juste
       * avant Wishlist Hero.
       */
      if (
        event.target.closest(
          '#wishlisthero-product-page-button-container button, ' +
          '#wishlisthero-product-page-button-container a'
        )
      ) {
        saveCurrentProductSize();

        setTimeout(
          saveCurrentProductSize,
          80
        );
      }

    },
    true
  );


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.closest(
          '.product__option[data-product-option]'
        )
      ) {
        setTimeout(
          saveCurrentProductSize,
          100
        );
      }

    }
  );


  /*
   * IMPORTANT :
   * interception AVANT le handler
   * ADD TO CART de Wishlist Hero.
   */
  document.addEventListener(
    'click',
    function (event) {

      const addButton =
        event.target.closest(
          '.wishlist-hero-list-card-footer-add-to-cart'
        );


      if (addButton) {
  const card = addButton.closest('.wishlist-hero-list-card');
  const item = card ? buildCartItem(card) : null;

  if (!item) {
    console.log('[WISHLIST] Variant introuvable, Wishlist Hero reprend la main');
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  addWishlistCardToCart(addButton);

  return;
}


      const addAllButton =
        event.target.closest(
          '.wishlist-hero-list-card-footer-add-all-to-cart-dialog'
        );


      if (addAllButton) {
        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        addAllWishlistToCart(
          addAllButton
        );
      }

    },
    true
  );



  /* =========================================================
     INITIALISATION
  ========================================================= */

  function init() {
    /*
     * Sauvegarde aussi la taille
     * sélectionnée à l'ouverture.
     */
    setTimeout(
      saveCurrentProductSize,
      200
    );


    updateWishlist();


    observer =
      new MutationObserver(
        scheduleUpdate
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();